import React, { Component } from 'react'
import { connect } from 'react-redux'

import { toggleOverlay } from 'store/actions/overlayAction'

import OverlayDefault from './overlay/OverlayDefault'
import OverlayClasses from './overlay/OverlayClasses'
import OverlayPlayer from './overlay/OverlayPlayer'
import OverlayPlayerClass from './overlay/OverlayPlayerClass'

import Container from 'ui/Container'
import Loader from 'ui/Loader'
import Icon from 'ui/Icon'

class Overlay extends Component{

  constructor(props){
    super(props)
    this.overlayComps = {
      default:{comp:OverlayDefault,size:'normal'},
      classes:{comp:OverlayClasses},
      player:{comp:OverlayPlayer},
      playerClass:{comp:OverlayPlayerClass},
    }
  }

  componentDidMount(){

  }


  componentDidUpdate(prevProps){
    //set close overlay if already active
    /*if(nextProps.data.isActive){
      setTimeout(()=>{
        this.props.dispatch(toggleOverlay(false))
      },nextProps.data.time);
    }*/
  }

  closeOverlay(){
    this.props.dispatch(toggleOverlay(false))
  }

  stopPropogation(e){
    e.stopPropagation()
  }

  getOverlay(){
    if(this.props.loading){
      return <Loader/>
    } else {
      //create default comp for first load
      const Comp = this.overlayComps[this.props.overlay.type || 'default'].comp
      return <Comp data={this.props.overlay.data}/>
    }
  }

  render(){
    const {isActive, type} = this.props.overlay
    return (
      <div className={`${isActive ? 'active' : ''} overlay-wrapper`}>
          <span className="overlay-close" onClick={()=>this.closeOverlay()}>
            <Icon name="close"/>
          </span>
          {this.getOverlay()}
      </div>
    )
  }

}

function mapStateToProps(store){
  return {
    overlay:store.overlay,
    loading:store.overlay.loading
  }
}

export default connect(mapStateToProps)(Overlay)



// WEBPACK FOOTER //
// ./src/components/Overlay.js